// extracted by mini-css-extract-plugin
module.exports = {"cmsRotator":"_f71b04a","contentWrapper":"_6d451df"};